<div fxLayout="row" fxLayoutAlign="start center">
  <span>{{ message }}</span>
  <mat-icon class="loader">
    <mat-spinner color="accent" diameter="20" />
  </mat-icon>
  <span fxFlex></span>
  <button mat-button (click)="snackBarRef.dismiss()">Dismiss</button>
</div>
